import { render, staticRenderFns } from "./UserViewProfileContent.vue?vue&type=template&id=f79b95ae"
import script from "./UserViewProfileContent.vue?vue&type=script&lang=js"
export * from "./UserViewProfileContent.vue?vue&type=script&lang=js"
import style0 from "./UserViewProfileContent.vue?vue&type=style&index=0&id=f79b95ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports